import React from 'react';
import { SparkDrawerContext } from 'contexts/SparkDrawerContext';
import type { SparkDrawerContextValue } from 'contexts/SparkDrawerContext';

// Define the types
interface SparkDrawerContextProps {
  children: React.ReactNode;
  initialRectModal: DOMRect | undefined;
}

// Create a Provider component
const SparkDrawerContextProvider = ({
  children,
  initialRectModal,
}: SparkDrawerContextProps) => {
  const contextValue: SparkDrawerContextValue = initialRectModal;

  if (!initialRectModal) {
    return <></>;
  }

  return (
    <SparkDrawerContext.Provider value={contextValue}>
      {children}
    </SparkDrawerContext.Provider>
  );
};

export default SparkDrawerContextProvider;
